
const Navigation = (navigate, url) => {
    if(window.navigator.userAgent=="appwebview"){
        window.open("https://libas.ae"+url)
    }else{
        navigate(url);
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
//window.navigator.userAgent=="appwebview" ? window.open("https://libas.ae"+url):navigate(url)&window.scrollTo({ top: 0, left: 0, behavior: "instant" })
};

export { Navigation };